import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import '../../sass/components/_components.header2025.scss';
import { StaticImage } from 'gatsby-plugin-image';
import rightArrow from '../../images/arrow-right.svg';
import performLogo from '../../images/Perform25-Planful-Logo.svg';
import useDynamicRefs from 'use-dynamic-refs';

const Header = ({ classCheck }) => {

    const [toggleCheck, setToggleCheck] = useState(false);

    const navToggle = () => {
        if (toggleCheck === false) {
            setToggleCheck(true);
            if (toggleCheckTwo === true) {
                setToggleCheckTwo(false);
            }
            if (toggleCheckThree === true) {
                setToggleCheckThree(false);
            }
        }
        else {
            setToggleCheck(false);
        }
    }

    const [toggleCheckTwo, setToggleCheckTwo] = useState(false);

    const navToggleTwo = () => {
        if (toggleCheckTwo === false) {
            setToggleCheckTwo(true);
            if (toggleCheck === true) {
                setToggleCheck(false);
            }
            if (toggleCheckThree === true) {
                setToggleCheckThree(false);
            }
        }
        else {
            setToggleCheckTwo(false);
        }
    }

    const [toggleCheckThree, setToggleCheckThree] = useState(false);

    const navToggleThree = () => {
        if (toggleCheckThree === false) {
            setToggleCheckThree(true);
            if (toggleCheck === true) {
                setToggleCheck(false);
            }
            if (toggleCheckTwo === true) {
                setToggleCheckTwo(false);
            }
        }
        else {
            setToggleCheckThree(false);
        }
    }

    const [getRef, setRef] = useDynamicRefs();

    const hamburgerClick = (index) => {
        getRef(index).current.nextElementSibling.classList.toggle('is-active');
        getRef(index).current.classList.toggle('is-active');
    };

    useEffect(() => {

    }, [hamburgerClick])

    return (
        <>
            <header className={`cp-header l--classCheck${classCheck}`}>
                <div className="cp-header__inner l--flex">
                    <div className="cp-header__left">
                        <a href="/perform/">
                            <img src={performLogo} alt="Planful" />
                        </a>
                    </div>
                    <div ref={setRef('hamburgerOpen')} className="cp-header__right l--flex">
                        <nav>
                            <ul>
                                <li className={`${toggleCheck ? 'l-active' : 'l-inactive'}`}>
                                    <a href="/perform/london/">London</a>
                                </li>
                                <li className={`${toggleCheck ? 'l-active' : 'l-inactive'}`}>
                                    <a href="/perform/perform-2025/">On-Demand</a>
                                </li>
                                <li>
                                    <button className={`${toggleCheckThree ? 'l-active' : 'l-inactive'}`} onClick={navToggleThree}>Agenda</button>
                                    {toggleCheckThree &&
                                        <ul className="l--toggledNav">
                                            {/* <li><a href="/perform/agenda-miami/">Miami Agenda</a></li> */}
                                            <li><a href="/perform/agenda-london/">London Agenda</a></li>
                                        </ul>
                                    }
                                </li>
                                <li>
                                    <button className={`${toggleCheck ? 'l-active' : 'l-inactive'}`} onClick={navToggle}>Get Involved</button>
                                    {toggleCheck &&
                                        <ul className="l--toggledNav">
                                            <li><a href="https://planful.customershome.com/login" target="_blank">Engage the community</a></li>
                                            <li><a href="/perform/faq/">FAQs</a></li>
                                        </ul>
                                    }
                                </li>
                                <li>
                                    <button className={`${toggleCheckTwo ? 'l-active' : 'l-inactive'}`} onClick={navToggleTwo}>Past Perform</button>
                                    {toggleCheckTwo &&
                                        <ul className="l--toggledNav">
                                            <li><a href="https://planful.com/perform/perform-2025/" target="_blank">Perform25</a></li>
                                            <li><a href="https://planful.com/perform/perform-2024/" target="_blank">Perform24</a></li>
                                        </ul>
                                    }
                                </li>
                            </ul>
                        </nav>
                        <a href="https://accounts.bizzabo.com/widgets/tickets/681703?widgetId=597883" target="_blank" className="l-button l-gtmTrigger">
                            <span>Register Now</span>
                            <img src={rightArrow} alt="" />
                        </a>
                    </div>
                    <button aria-label="Click icon to open navigation" className="cp-booktoggle__hamburger js-hamburger-toggle" onClick={() => hamburgerClick('hamburgerOpen')} aria-live="polite">
                        <span className="visually-hidden l-nav"></span>
                        <span className="cp-booktoggle__hamburger--icon js-hamburger-child">
                            <span></span><span></span><span></span><span></span><span></span><span></span>
                        </span>
                    </button>
                </div>
            </header>
        </>
    )
}

export default Header;